export default "https://cdn-static.gokick.com/assets/d05c895b658955f243e3d6e9c630166e56cf3faa/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";